import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';
import getLocusUrlString from './get-locus-url-string';

const {defaultPartner} = appConfig;

export const checkDayUseSRPVersionUnif = ({isSeo, unified_hourly_listing_web}) => {
  // If it's SEO, return false
  if (isSeo) {
    return false;
  }

  // Return the value of unified_hourly_listing_web directly
  return !!unified_hourly_listing_web;
};

export default function getDayUseSrpRouteUrl({
  checkin,
  roomString,
  destination,
  locus = {},
  partner = defaultPartner,
  country = '',
  filter = {},
  shouldEncode = false,
  selectedRegionCity = {},
  checkinTime,
  newFilterData = '',
  newLocationData = '',
  sort = '',
  newSelectedSlot = '',
}) {
  const {date: checkinDate} = checkin;

  const {n: destinationCityName = '', _id, xtr = {}, ct = {}, t = ''} = destination;
  let cityName = destinationCityName;
  let cityId = _id;
  const {cc = 'in'} = xtr; // default as india

  if (xtr && xtr.flt) {
    const {n: voyCityName = '', _id: voyCityId = ''} = ct;
    cityName = voyCityName;
    cityId = voyCityId;
  }

  let nQueryString = {};

  let tempfilterObj = {filter: {...filter}};

  let intermittent = JSON.stringify(tempfilterObj).split('/').join('');

  if (shouldEncode) {
    intermittent = encodeURIComponent(intermittent);
  }

  nQueryString = '?' + intermittent;

  const ccQ = (country && `&cc=${country}`) || '';

  const ci_date = (checkinDate && `&checkin_date=${parseDateIntoHermesString(checkinDate)}`) || '';
  const rs = (roomString && `&roomString=${roomString}`) || '';
  const ci_time = (checkinTime && `&checkin_time=${checkinTime}`) || '';
  const filterData = (!!newFilterData && `&filterData=${newFilterData}`) || '';
  const locationData = (!!newLocationData && `&locationData=${newLocationData}`) || '';
  const sortApplied = !!sort ? `&sort=${sort}` : '';

  const sec = cc.toLowerCase() === 'in' ? '&sec=dom' : '&sec=int';
  const type = t === 'region' ? '&type=region' : '';
  const rCity = selectedRegionCity?.id ? `&region_city=${selectedRegionCity.id}` : '';
  const locusUrlStr = getLocusUrlString(locus);
  const newSelectedSlotStr = newSelectedSlot ? `&selectedSlot=${newSelectedSlot}` : '';
  return `/hotels/find-hourly-hotels-in-${cityName}/${cityId}/${cityId}/${nQueryString}${sec}${ccQ}${type}${rCity}${ci_date}${rs}${ci_time}${locusUrlStr}${filterData}${locationData}${sortApplied}${newSelectedSlotStr}`;
}
